import { createSelector } from 'reselect';

import { POPUPS_LEGACY_MODULE_NAME } from '../constants';
import { IDialogPopup, PopupType } from '../types';

import { IState } from './reducer';

const getState = (state: { [POPUPS_LEGACY_MODULE_NAME]: IState }) => state[POPUPS_LEGACY_MODULE_NAME];

const selectPopups = createSelector(getState, state => state.popups);

const selectPopupById = createSelector(
    selectPopups,
    (state: unknown, popupId: string) => popupId,
    (popups, popupId) => popups.find(m => m.id === popupId),
);

const selectDialogPopups = createSelector(selectPopups, popups => popups.filter(p => p.type === PopupType.Dialog) as IDialogPopup<unknown>[]);

const selectIsLegacyModalOpened = createSelector(selectPopups, legacyModals => legacyModals.length > 0);

export { selectDialogPopups, selectIsLegacyModalOpened, selectPopupById, selectPopups };
